import * as React from 'react';
import {StorageSuccessModal} from "./StorageSuccessModal";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../pages/dashboard/annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import {ProductsEnum, resourcesHelper} from "@falcon/services";

interface IProps {
    product: ProductsEnum;
}

export class RenewNextYearConfirmationModal extends React.Component<IProps> {
    public render(): React.ReactNode {
        const productWording: string = this.props.product === ProductsEnum.WOLF_MOTOR ?
            `${resourcesHelper.PRODUCT} Car Insurance policy` : `${resourcesHelper.PRODUCT} Home Insurance policy`;

        return (
            <StorageSuccessModal
                title="All done!"
                explanationWording={
                <>
                    <p>We'll let you know your new price and cover details in plenty of time before your renewal date and you can opt out any time you like, free of charge.</p>
                    <p className="font-weight-bold">
                        You have set up your {productWording} to renew next year.<br/>
                        You do not need to inform us of the change by email or do anything else.
                    </p>
                </>}
                anythingElseTitle={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle()}
                explanationAnythingElseWording={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody()}
            />
        )
    }
}
